import React, { FormEvent, ChangeEvent } from 'react';
import { ActionButton } from '../../action-button/ActionButton';

export type PromoCodeData = {
  visible?: boolean;
  value?: string;
  submitted?: boolean;
  applyDisabled?: boolean;
  appliedSuccessfully?: boolean;
  applicationError?: string | null;
  successMessage?: string | null;
  placeholder?: string;
  applyLabel?: string;
  onChange?: (value: string) => void;
  onApply?: () => void;
  onClear?: () => void;
};

function PromoInputRow({ promo }: { promo: PromoCodeData }) {
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    promo.onChange?.(event.target.value);
  };

  return (
    <div className="apply-promo-code-field">
      <input
        id="promo-code-input-field"
        type="text"
        placeholder={promo.placeholder}
        aria-label={promo.placeholder || 'Promo code'}
        disabled={!!promo.submitted}
        maxLength={30}
        value={promo.value || ''}
        onChange={onChange}
      />
      {promo.submitted ? (
        <div className="clear-promo-code-btn visible">
          <ActionButton
            data={{
              ariaLabel: 'Clear',
              variant: 'primary',
              type: 'button',
              leadingIcon: 'icon-circled-x',
              iconOnly: true,
              onClick: promo.onClear,
            }}
          />
        </div>
      ) : null}
    </div>
  );
}

function PromoSuccessMessage({ promo }: { promo: PromoCodeData }) {
  if (!promo.appliedSuccessfully || !promo.successMessage) {
    return null;
  }

  return <span className="promo-code-field-feedback">{promo.successMessage}</span>;
}

function PromoErrorMessage({ promo }: { promo: PromoCodeData }) {
  if (!promo.applicationError) {
    return null;
  }

  return (
    <span id="promo-code-error-label" className="promo-code-field-feedback" role="alert">
      {promo.applicationError}
    </span>
  );
}

export function PromoCodeField({ promo }: { promo: PromoCodeData }) {
  if (!promo.visible) {
    return null;
  }

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (!promo.applyDisabled) {
      promo.onApply?.();
    }
  };

  return (
    <div className="component-promo-code-field">
      <div className="content-group">
        <form className="apply-promo-code-form" onSubmit={onSubmit}>
          <PromoInputRow promo={promo} />
          <ActionButton
            data={{
              id: 'apply-promo-code-btn',
              label: promo.applyLabel || 'Apply',
              variant: promo.applyDisabled ? 'disabled' : 'primary',
              type: 'submit',
            }}
          />
        </form>
        <PromoSuccessMessage promo={promo} />
        <PromoErrorMessage promo={promo} />
      </div>
    </div>
  );
}
